






















import { Component, Vue, Prop } from 'vue-property-decorator'
import Axios from 'axios'
import { Playlist, PLAYLIST_TYPES } from '@/classes/playlist'
import { USAGE_STAT_FEATURES } from '../../../../../system/usage-stats'

@Component({
  components: {
    BaseAction: require('./_Base').default
  }
})
export default class Create extends Vue {
  @Prop()
  selectedPlaylists: Playlist[]

  get validation(): { message?: string, valid: boolean } {
    if (this.selectedPlaylists.length === 0) return { valid: false }

    return { valid: true }
  }

  get anyPlaylistIsFolder(): boolean {
    return this.selectedPlaylists.some(x => x.type === PLAYLIST_TYPES.Folder)
  }

  async save() {
    if (!this.validation.valid) return

    window.addUsageStat(USAGE_STAT_FEATURES.ManagePlaylist, 'delete', 'confirm')

    return Axios.post('/playlist/delete', {
      playlistIds: this.selectedPlaylists.map(x => x._id)
    }).then((res) => {
      this.$buefy.notification.open('Deleted playlist' + (this.selectedPlaylists.length === 1 ? '' : 's'))

      return res
    })
  }
}
